module.exports = __webpack_public_path__ + "img/36d7a12.jpg";